import(/* webpackMode: "eager" */ "/codebuild/output/src1654997829/src/src/app/global-error.tsx");
